import { render, staticRenderFns } from "./third-party.vue?vue&type=template&id=130fea24&scoped=true"
import script from "./third-party.vue?vue&type=script&lang=js"
export * from "./third-party.vue?vue&type=script&lang=js"
import style0 from "./third-party.vue?vue&type=style&index=0&id=130fea24&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130fea24",
  null
  
)

export default component.exports